import React from 'react';
import './../quizz/style/fonts.module.css';

const Checkbox = ({
  name,
  id,
  checked,
  handleChange,
  disabled = false,
  red = false,
}) => {
  return (
    <div className="relative flex items-center gap-2">
      <input
        type="checkbox"
        name={name}
        id={id}
        onChange={handleChange}
        checked={checked}
        disabled={disabled}
        className={`size-5 transform cursor-pointer appearance-none rounded border-2 ${
          checked 
            ? 'border-[#FF8036] bg-white' 
            : 'border-[#CFD1D5] bg-white'
        } transition duration-[120ms] ease-in-out disabled:cursor-auto`}
        aria-checked={checked}
      />
      {checked && (
        <span className="pointer-events-none absolute top-[2px] left-[7px] transform text-sm font-bold text-[#FF8036]">
          ✓
        </span>
      )}
    </div>
  );
};

export default Checkbox;